import { render, staticRenderFns } from "./DesignComponentsButton.vue?vue&type=template&id=2b03cfa5"
import script from "./DesignComponentsButton.vue?vue&type=script&lang=js"
export * from "./DesignComponentsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsButton.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports